import Vue from 'vue'

var order = {
    setSessionStorage(orderList){
        sessionStorage.clear()
        var length = orderList.length
        var tmpCount = 0
        var tmpCount2 = 0

        for(var count = 0; count < orderList.length; count++){
            if(count == 0){
                if(length == 1){
                    sessionStorage.setItem(orderList[count].orderId, 0 + ',' + 0);
                } else {
                    tmpCount = count + 1
                    sessionStorage.setItem(orderList[count].orderId, 0 + ',' + orderList[tmpCount].orderId);
                }
            } else if(count == (length -1)){
                tmpCount = count - 1
                sessionStorage.setItem(orderList[count].orderId, orderList[tmpCount].orderId + ',' + 0);
            } else {
                tmpCount = count - 1
                tmpCount2 = count + 1
                sessionStorage.setItem(orderList[count].orderId, orderList[tmpCount].orderId + ',' + orderList[tmpCount2].orderId);
            }
        }
    },
    getSessionStorage(orderId){
        var orderIds = sessionStorage.getItem(orderId)
        if (orderIds == null){
            orderIds = ""
        }
        return orderIds
    }
}

Vue.use({
	install(Vue, options) {
		Vue.prototype['$order'] = order
	}
})

export default order



// WEBPACK FOOTER //
// ./src/services/order.js